export const BRAND_NAME = 'Review Circle';
export const BRAND_URL = 'https://reviewcircle.com';
export const BRAND_LOGO = 'logo-blue.png';
export const BRAND_LOGO_CONSTRAST = 'logo-white.png';
export const GOOGLE_LOGO = 'google.png';
export const JUMBOTRON = {
  LOGIN: {
    title: `Login to ${BRAND_NAME}!`,
    description: 'Managing your business with AI-powered suite tools',
  },
};
